'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Upload(_ref) {
  var size = _ref.size,
      color = _ref.color;

  return _react2.default.createElement(
    'svg',
    {
      width: size,
      height: size - 4,
      viewBox: '0 0 18 14',
      version: '1.1',
      xmlnsXlink: 'http://www.w3.org/1999/xlink'
    },
    _react2.default.createElement(
      'g',
      {
        transform: 'translate(-1.000000, -3.000000)',
        stroke: 'none',
        strokeWidth: 1,
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        d: 'M15.55 7.5A5.645 5.645 0 0 0 10 3C7.825 3 5.95 4.2 5.05 6 2.725 6.3 1 8.175 1 10.5 1 12.975 3.025 15 5.5 15h9.75c2.1 0 3.75-1.65 3.75-3.75 0-1.95-1.575-3.6-3.45-3.75zm-2.55 6h2.25c1.275 0 2.25-.975 2.25-2.25S16.525 9 15.25 9h-1.125v-.375C14.125 6.375 12.25 4.5 10 4.5c-1.875 0-3.45 1.275-3.975 3H5.5c-1.65 0-3 1.35-3 3s1.35 3 3 3H7V15h6v-1.5z',
        fill: color
      }),
      _react2.default.createElement('path', {
        d: 'M15.25 13.5H5.5c-1.65 0-3-1.35-3-3s1.35-3 3-3h.525c.525-1.725 2.1-3 3.975-3 2.25 0 4.125 1.875 4.125 4.125V9h1.125c1.275 0 2.25.975 2.25 2.25s-.975 2.25-2.25 2.25z',
        fill: '#FFF',
        opacity: '0.5'
      }),
      _react2.default.createElement('path', {
        d: 'M6.929 12.132h1.806v4.42a.448.448 0 0 0 .126.316.391.391 0 0 0 .297.132h1.682a.391.391 0 0 0 .297-.132.448.448 0 0 0 .126-.316v-4.42h1.806a.394.394 0 0 0 .39-.274.423.423 0 0 0-.093-.493l-3.075-3.232a.394.394 0 0 0-.591 0l-3.068 3.235a.423.423 0 0 0-.09.492c.053.166.211.277.387.272z',
        fill: color
      })
    )
  );
}

Upload.defaultProps = {
  color: '#000'
};

Upload.propTypes = {
  size: _propTypes2.default.number.isRequired,
  color: _propTypes2.default.string
};

exports.default = Upload;